export default {
  dismissed(state, payload) {
    state.dismissed = payload;
    return state;
  },

  dismissedAt(state, payload) {
    state.dismissedAt = payload;
    return state;
  },

  isOpen(state, payload) {
    state.isOpen = payload;
    return state;
  },

  isLoading(state, payload) {
    state.isLoading = payload;
    return state;
  },

  isError(state, payload) {
    state.isError = payload;
    return state;
  },

  hasData(state, payload) {
    state.hasData = payload;
    return state;
  },

  errorMessage(state, payload) {
    state.errorMessage = payload;
    return state;
  },
};
